import React from 'react';
import { getUserProfile } from '../utils/userStorage.ts';

const UserProfileDisplay: React.FC = () => {
    const userProfile = getUserProfile();

    if (!userProfile) {
        return null;
    }

    return (
        <div className="bg-white rounded-xl p-4 shadow-lg mb-4">
            <div className="flex items-center space-x-3">
                <img
                    src={userProfile.photo}
                    alt="Profile"
                    className="w-12 h-12 rounded-full object-cover border-2 border-gray-200"
                />
                <div className="flex-1">
                    <p className="font-bold text-gray-800 truncate" style={{ fontFamily: 'Feather Bold' }}>
                        {userProfile.username}
                    </p>
                    <p className="text-sm text-gray-600" style={{ fontFamily: 'DIN Next Rounded' }}>
                        Pelajar Aksara
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UserProfileDisplay;
